module.exports = __webpack_public_path__ + "static/date_pc-2a7782b7c7c3240c04a3ff53228a551b.svg";